const messages = {
  title: "Ценоразписи и продуктови брошури",
  description:
    "Изтеглете тук най-новите брошури и листовки за нашите гуми Bridgestone и Firestone за леки автомобили, SUV и търговски превозни средства.",
  brochureCategories: {
    products: "Продукти",
    brand_and_solutions: "Марка и решения",
    season_and_promotions: "Сезон и промоции",
    format: "Формат",
    cars_and_vans: "Автомобил, SUV, комунален",
    summer: "Лято",
    winter: "Зима",
    promotions: "Промоции",
    all_season: "Всички сезони",
    truck_and_buses: "Тежкотоварни автомобили и автобуси",
    motorcycle: "Мотоциклет",
    agriculture: "Селско стопанство",
    construction_machinery: "Строителни машини",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Материали",
    brochures: "Продуктови брошури",
    price_list: "Ценоразписи",
    materials: "Материали",
    video_in_store: "Видео със субтитри",
    video_online: "Видео без субтитри",
    banner_website: "Банер",
    banner_social_media: "Социални мрежи",
    logos: "Логота",
  },
  searchMedia: "Въведете ключова дума",
  searchResults: "Резултати от търсенето",
};

export default {
  messages,
};
